import { type Action } from 'react-sweet-state';

import type { ChatModeInternal } from './ChatModeInternal';
import { getDerivedDefaultChatMode } from './getDerivedDefaultChatMode';
import type { ChatModeState } from './types';

export const updateMode: (
	key: string,
	mode: Partial<ChatModeInternal>,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
) => Action<ChatModeState, any, any> = (key: string, mode: Partial<ChatModeInternal>) => {
	return ({ setState, getState }) => {
		const state = getState()[key] || getDerivedDefaultChatMode();
		setState({
			[key]: {
				...state,
				...mode,
			},
		});
	};
};
